import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';

export default function getAddress(params) {
    const { baseUrl, brandId, country, addressId, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of getAddress()');
    invariant(brandId, 'brandId is a required param of getAddress()');
    invariant(country, 'country is a required param of getAddress()');
    invariant(addressId, 'addressId is a required param of getAddress()');
    invariant(uberToken, 'uberToken is a required param of getAddress()');
    invariant(clientId, 'clientId is a required param of getAddress()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self/contact/byAddressId/${addressId}`;

    return labelRequest(authenticatedRequest(new Request(url, { headers: new Headers(headers) }), uberToken, clientId, clientSecret), 'getAddress');
}
